import { handleRequestDataForOrganizations } from "../../actions/UserActions/HandleUserActions";
import React from "react";
import { SovosButton } from "mosaic-react";
import { SovosIcon } from "mosaic-react";
import { FileCopy } from "mosaic-react-icons";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";

const OrganizationalReportButton = (props) => {
    const { i18n, organizationId, pushModal, reload } = props;
    const { pushNotification } = useGlobalValue();
    return (
        <SovosButton
            startIcon={
                <SovosIcon>
                    <FileCopy />
                </SovosIcon>
            }
            variant={"text"}
            onClick={() => {
                pushModal({
                    title: "Organization Report",
                    data: {
                        listProps: { ...props, pushNotification, handleRequestDataForOrganizations },
                        organizationId: organizationId,
                        __typename: "OrganizationData",
                    },
                    args: {
                        organizationId: organizationId,
                    },
                    view: "OrganizationDataForm",
                })
                    .then(() => {
                        reload();
                    })
                    .catch(() => null);
            }}
        >
            {i18n`Organization Report`}
        </SovosButton>
    );
};

export default OrganizationalReportButton;
